import { handleAPI, API_VERSION_ONE } from '../../../../../itrust_common/utils/apiUtils';

export function eyefinityInsuranceDetailView(data) {
  return {
    type: 'EYEFINITY_INSURANCE_DETAIL_VIEW',
    data
  };
}

export function eyefinityLensOptionsLoad(orderId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${orderId}/eyefinity_lens_options`;
  const method = 'GET'
  return {
    type: 'EYEFINITY_LENS_OPTIONS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function eyefinityInsuranceEligibilityEdit(data) {
  return {
    type: 'EYEFINITY_INSURANCE_ELIGIBILITY_EDIT',
    data
  };
}
